const initialState = {
    anchor: 'left',
    motivoDesistencia: [],
    open: false,
    id: '',
    codigo: '',
    nome: '',
    data_cadastro: '',
    data_exclusao: '',
    motivoDesistencia_cadastro: 0,
    motivoDesistencia_exclusao: 0
};

export function motivoDesistencia(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_MOTIVO_DESISTENCIA':
            return {
                ...state,
                motivoDesistencia: action.motivoDesistencia
            };
        case 'MOTIVO_DESISTENCIA_DETAIL':
            return {
                ...state,
                id: action.id,
                codigo: action.codigo,
                nome: action.nome,
                data_cadastro: action.data_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_cadastro: action.usuario_cadastro,
                usuario_exclusao: action.usuario_exclusao  
            };
        case 'MOTIVO_DESISTENCIA_CLEAR':
            return {
                ...state,
                anchor: 'left',
                motivoDesistencia: [],
                open: false,
                id: '',
                codigo: '',
                nome: '',
                data_cadastro: '',
                data_exclusao: '',
                motivoDesistencia_cadastro: 0,
                motivoDesistencia_exclusao: 0
            };
        case "MOTIVO_DESISTENCIA_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
